import districtsService from "api/districtsService";
import { useMutation } from "react-query";

const useDeleteDistrictMutation = () => {
  return useMutation(async(districtId: number) => {
    try {
      const res = await districtsService.deleteDistrict(districtId)

      return res.data
    } catch(err: any) {
      return {
        err: err.message,
        errStatus: err.response.status,
      }
    }
  })
}

export default useDeleteDistrictMutation